import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cutName',
})
export class CutNamePipe implements PipeTransform {
  transform(value: string, ...args: any[]): any {
    const fileExtensionPosition = value.lastIndexOf('.');
    if (args[0] === 'fileExtension') {
      if (fileExtensionPosition > -1) {
        value = value.substr(fileExtensionPosition);
        return value;
      } else {
        return '';
      }
    }
    if (fileExtensionPosition > 0) {
      value = value.substr(0, fileExtensionPosition);
    }
    if (fileExtensionPosition === 0) {
      value = '';
    }
    if (value.length > 30) {
      value = value.substr(0, 30);
      value += ' ... ';
    }
    return value;
  }
}
